// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { apis } from './environment.shared';

export const environment = {
  version: 'v1.0.28',
  production: true,
  hostPath: 'https://zolfrontapidev.azurewebsites.net',
  secretKey: 'Yuz7ZoQrgRRk14NKKdgzzKXtL95rmzua5sVuq+Vdvdg=',
  apis: apis,
  localGenCustomerId: 999,
  optExpireInSec: 60,
  optPrefix: 'htwt',
  optMaxFailBypass: 3,
  optResendInSec: 60,
  optMobileCharNumShow: 4,
  pwdResetRedirectInSec: 5,
  hostName: 'zolfrontssrdev',
  eorderChannel: 'MY',
  defaultSubTag: 'zeoniqmydev',
  defaultChannelTag: 'MY',
  subscription: '00002',
  firebase: {
    apiKey: "AIzaSyCeKXprJVThPmMZbz78OErJ-ODSRVmFQqo",
    authDomain: "e-order-dev-zeoniq.firebaseapp.com",
    projectId: "e-order-dev-zeoniq",
    storageBucket: "e-order-dev-zeoniq.firebasestorage.app",
    messagingSenderId: "456449498330",
    appId: "1:456449498330:web:b7d66344ef8b70ce9419e3",
    measurementId: "G-Y57LH0GSJV"
  },
  enableDineIn: true,
  shareRewardDomain: "https://zolfrontssrdev.azurewebsites.net/",
  guestMobileNo: "0111111111",
  guestPassword: "123123123",
  timeToRemove: 2,
  origin: "https://zolfrontssrdev.azurewebsites.net/",
  enableShareVch: true,
  appInsights: {
    instrumentationKey: ''
  },
  qrCountdownSec: 600,
  qrCountdownAlertSec: 60,
};
